/**
 * Traitement facture PA/PREDIK360 (PRED-3268) : libellés et étoile jaune partagés entre la modale,
 * la liste Fournisseurs (ligne + légende), le titre de la fiche et la carte Informations.
 */
export const ELECTRONIC_INVOICE_FIELD_LABEL = 'Traitement facture PA/PREDIK360';
export const ELECTRONIC_INVOICE_LEGEND_LABEL = 'Conforme PA/PREDIK360';
/** Nom d'icône Material (rendu via `mat-icon`). */
export const ELECTRONIC_INVOICE_ICON = 'star';
export const ELECTRONIC_INVOICE_ICON_COLOR = '#FBC02D';
